import React from 'react';
import { Box, Button, CircularProgress, Stack, Typography, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import {
  getRiskNoMatchAlertSx,
  getRiskNoMatchBodySx,
  getRiskNoMatchTitleSx,
  riskButtonSx,
} from './riskComplianceStyles';

export default function DunsNoMatchAlert({ labels, onInvestigate, isInvestigating, investigationRequested = false }) {
  const theme = useTheme();
  const title = investigationRequested ? labels.investigationRequestedTitle : labels.title;
  const description = investigationRequested ? labels.investigationRequestedDescription : labels.description;

  return (
    <Box sx={getRiskNoMatchAlertSx(theme)}>
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <ErrorOutlineIcon sx={{ color: theme.palette.warning.dark, fontSize: 22, mt: 0.25, flexShrink: 0 }} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            variant="subtitle2"
            fontWeight={theme.typography.fontWeightBold}
            sx={getRiskNoMatchTitleSx(theme)}
          >
            {title}
          </Typography>
          <Typography variant="body2" sx={{ ...getRiskNoMatchBodySx(theme), mb: investigationRequested ? 0 : 2 }}>
            {description}
          </Typography>
          {!investigationRequested && onInvestigate && (
            <Button
              variant="contained"
              startIcon={isInvestigating ? <CircularProgress size={16} color="inherit" /> : <AssignmentOutlinedIcon />}
              onClick={onInvestigate}
              disabled={isInvestigating}
              sx={riskButtonSx}
            >
              {labels.initiateInvestigation}
            </Button>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
